import Header from "./components/Header"
import Hero from "./components/Hero"
import AboutMe from "./components/AboutMe"
import EducationExperience from "./components/EducationExperience"
import ProjectsSkills from "./components/ProjectsSkills"
import Footer from "./components/Footer"
import { ThemeProvider } from "./components/ThemeContext"

function App() {
  return (
    <ThemeProvider>
      <div className="min-h-screen bg-white dark:bg-gray-900 transition-colors">
        <Header />
        <Hero />
        <AboutMe />
        <EducationExperience />
        <ProjectsSkills />
        <Footer />
      </div>
    </ThemeProvider>
  )
}

export default App